// extracted by mini-css-extract-plugin
export default {"root":"appearance_root__SPctg"};